import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import router from '@/router'
import store from './stores/store'
import Loading from 'vue-loading-overlay'
import { firebaseAuth } from './config/firebaseConfig'
import './assets/styles/app.scss'

import App from './App.vue'
import './filters.js'
import VueHtmlToPaper from 'vue-html-to-paper'

// import 'vue-tel-input/dist/vue-tel-input.css'
require('./assets/styles/style.css')
require('../node_modules/vue-loading-overlay/dist/vue-loading.css')
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
// router.beforeEach((to, from, next) => {
//     if (to.onlyGuest && store.getters.isLoggedIn) {
//         next('/');
//     } else {
//         next();
//     }
// });
Vue.use(VueLodash, { lodash: lodash })
Vue.use(Loading)

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ]
}

Vue.use(VueHtmlToPaper, options)

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')

firebaseAuth().onAuthStateChanged(function (user) {
  store.dispatch('authStateChanged')
  if (!user && router.currentRoute.path !== '/register') {
    router.push('/register')
  } else if (user && (router.currentRoute.path === '/register' || router.currentRoute.path === '/login')) {
    router.push('/')
  }
})
